// side padding used for the main container for each screen
// these values are derived from zeplin px measurements and are converted to rem
export const mobileGutter = 1.875
export const tabletGutter = 3.0625

export const titleBarHeight = 3.75
